/**
 * Web build of the maps loader: react-native-maps has no web support, so
 * the map surfaces render nothing on web. Metro picks this file for web
 * bundles, keeping react-native-maps out of them entirely.
 */
export type MapsModuleType = typeof import('react-native-maps');

export function loadMapsModule(): MapsModuleType | null {
  return null;
}
